var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbars',{attrs:{"objects":_vm.objects,"top":"","right":""},on:{"update:objects":function($event){_vm.objects=$event}},scopedSlots:_vm._u([{key:"action",fn:function({ close }){return [_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return close()}}},[_vm._v("Sluiten")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }